import React, { ReactElement } from "react";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppButton } from "../../Generic/AppButton";

interface Props {
  isOpen: boolean;
  onClickYes: () => void;
  onClickNo: () => void;
  onRequestDismiss: () => void;
}

export function AreYouWorkingWithAnAgencyBottomSheet(props: Props): ReactElement {
  return (
    <AppBottomSheet
      isOpen={props.isOpen}
      title={translate(STRINGS.ARE_YOU_CURRENTLY_WORKING_WITH_AN_AGENCY)}
      className="AreYouWorkingWithAnAgencyBottomSheet"
      onRequestClose={props.onRequestDismiss}
    >
      <AppButton color="white" variant="outline" onClick={props.onClickYes}>
        {translate(STRINGS.YES)}
      </AppButton>

      <AppButton color="white" variant="outline" onClick={props.onClickNo}>
        {translate(STRINGS.NO)}
      </AppButton>
    </AppBottomSheet>
  );
}
